// extracted by mini-css-extract-plugin
export var colorSquare = "_qp-0";
export var danger = "_qp-5";
export var lightPink = "_qp-8";
export var neutralBlue = "_qp-7";
export var neutralYellow = "_qp-6";
export var normal = "_qp-1";
export var primary = "_qp-2";
export var primaryLight = "_qp-3";
export var solidBlack = "_qp-g";
export var solidGreen = "_qp-b";
export var solidLightBlue = "_qp-d";
export var solidNavy = "_qp-c";
export var solidOrange = "_qp-f";
export var solidPink = "_qp-e";
export var solidRed = "_qp-9";
export var solidYellow = "_qp-a";
export var success = "_qp-4";